import asyncSeries from 'async/series';
import React from 'react';
import {
  Routes,
  Route,
  useOutlet,
  useLocation,
  useNavigate,
  Navigate,
} from 'react-router-dom';

import ModalDialog from './components/dialogs/modal_dialog';
import StandardScreen from './components/standard_screen';

import HomeScreen from './home_screen';
import LoadingScreen from './loading_screen';
import LoginScreen from './login_screen';
import LogoutScreen from './logout_screen';
import NotFoundScreen from './not_found_screen';
import OrgListScreen from './org_list_screen';
import OrgScreen from './org_screen';

import Stores from './stores';
import Managers from './managers';

import UserStore from './stores/user_store';

import Analytics from './tools/analytics';
import Api from './tools/api';
import util from './tools/util';

import './css/colors.css';

const _startup = util.herdOnce((done: any) => {
  util.log('ares-admin: startup:', util.getVersion());
  util.setDebugLogger(Analytics.log);
  Analytics.init();
  asyncSeries([Api.init, Stores.init, Managers.init], (err) => {
    if (err) {
      util.errorLog('ares-admin: startup err:', err);
    }
    util.log('ares-admin: startup done');
    Analytics.loadFinish();
    done();
  });
});

export default function App() {
  const [is_loading, setLoading] = React.useState(true);
  const start_url = useLocation()?.pathname;
  const navigate = useNavigate();
  React.useEffect(
    () =>
      _startup(() => {
        if (!UserStore.isReady()) {
          navigate('/loading', { state: { from: start_url ?? '/' } });
        }
        setLoading(false);
      }),
    //eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  let content: any = null;
  if (is_loading) {
    content = <LoadingScreen noNav={true} />;
  } else {
    content = (
      <>
        <Routes>
          <Route path='/loading' element={<LoadingScreen forever={true} />} />
          <Route path='/login' element={<LoginScreen />} />
          <Route path='/logout' element={<LogoutScreen />} />
          <Route element={<ProtectedLayout />}>
            <Route path='/' element={<HomeScreen />} />
            <Route path='/org' element={<OrgListScreen />} />
            <Route path='/org/:org_id' element={<OrgScreen />} />
          </Route>
          <Route path='*' element={<NotFoundScreen />} />
        </Routes>
        <ModalDialog />
      </>
    );
  }
  return content;
}
function ProtectedLayout(props) {
  const outlet = useOutlet();
  return <ProtectedRoute>{outlet}</ProtectedRoute>;
}
function ProtectedRoute(props) {
  const is_logged_in = UserStore.useIsLoggedIn();
  const location = useLocation();
  return is_logged_in ? (
    <StandardScreen>{props.children}</StandardScreen>
  ) : (
    <Navigate to='/login' state={{ from: location.pathname }} />
  );
}
